export const createInitials = (name: string) => {
  let initials = { label: '', state: 'danger' }
  const states = ['warning', 'danger', 'primary', 'success', 'info']

  // Generate a more secure random index
  const randomArray = new Uint32Array(1)
  window.crypto.getRandomValues(randomArray)
  const random = randomArray[0] % states.length

  initials.state = states[random] // Assign random colour

  if (name?.length > 0) {
    initials.label = name
      .split(' ')
      .map((substr: string, index: number) => {
        if (index < 2 && substr.length > 0) {
          return substr[0].toLocaleUpperCase()
        } else {
          return null
        }
      })
      .filter((char) => char !== null)
      .join('')
  }

  return initials
}
